import { v4 } from 'uuid'

export const createImageItem = ({ file = null, id, image = null, youTubeVideoId = null }) => ({
  file,
  image: image ? image : file ? URL.createObjectURL(file) : null,
  id: id ? id : v4(),
  isVideo: Boolean(youTubeVideoId),
})

export const getYouTubeId = (url) => {
  if (!url) return ''
  const splitedUrl = url?.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  if (splitedUrl[2] !== undefined) {
    const params = splitedUrl[2].split(/[^0-9a-z_\\-]/i)
    return params[0]
  } else {
    return splitedUrl
  }
}

export const getTweetId = (tweetUrl) => {
  if (!tweetUrl) return 0
  const tweetIdPattern = /\/status\/(\d+)/
  const tweetIdMatch = tweetUrl?.match(tweetIdPattern)
  return tweetIdMatch?.length ? tweetIdMatch[1] : 0
}

export const getYoutubeVideoPreview = (url) => {
  const src = `https://i3.ytimg.com/vi/${getYouTubeId(url)}`
  const img = new Image()
  img.src = `${src}/maxresdefault.jpg`
  if ((img.width === 120) & (img.height === 90)) {
    return `${src}/hqdefault.jpg`
  } else return img.src
}

const linksGenerator = (linkYoutube) => {
  try {
    const url = linkYoutube && new URL(linkYoutube)
    return url?.searchParams.get('t')
  } catch {
    return 0
  }
}
export const getYoutubeVideoSrc = (url) => {
  const startTime = linksGenerator(url)
  return `https://www.youtube.com/embed/${getYouTubeId(url)}?start=${startTime}`
}

export const getMediaItems = (images, videos) => {
  const mappedImages = images?.map((item) => ({ src: item?.large || item?.medium, isVideo: false }))
  const mappedVideos = videos?.map((item) => ({
    src: getYoutubeVideoPreview(item),
    link: item,
    isVideo: true,
  }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return [...(mappedImages || []), ...(mappedVideos || [])]
}
